/**
 * Pure mapping of the current user's account flags to the profiles they can
 * switch to. Mirrors the legacy SwitchProfileMenu buttons exactly: same
 * order, same i18n keys, same profile-change side effects (the student
 * switch never cleared the cached user in the legacy menu, so it does not
 * here either).
 */

export type SwitchableProfileValue = 'manager' | 'tutor' | 'student' | 'guardian'

export interface SwitchableProfile {
  readonly value: SwitchableProfileValue
  readonly labelKey: string
  readonly clearsCachedUser: boolean
}

export interface ProfileAccountFlags {
  readonly managed_accounts: boolean
  readonly tutor_account: boolean
  readonly student_account: boolean
  readonly guardian_account: boolean
}

export const getSwitchableProfiles = (user?: ProfileAccountFlags): SwitchableProfile[] => {
  if (!user) return []

  const profiles: SwitchableProfile[] = []
  if (user.managed_accounts) profiles.push({ value: 'manager', labelKey: 'school_manager', clearsCachedUser: true })
  if (user.tutor_account) profiles.push({ value: 'tutor', labelKey: 'general_profiles_tutor', clearsCachedUser: true })
  if (user.student_account) {
    profiles.push({ value: 'student', labelKey: 'general_profiles_student', clearsCachedUser: false })
  }
  if (user.guardian_account) profiles.push({ value: 'guardian', labelKey: 'guardian', clearsCachedUser: true })
  return profiles
}
